import React, { useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import Navbar from '../components/Navbar/Navbar';

// Importa tus imágenes
import FacebookIcon from '../img/facebook.svg';
import InstagramIcon from '../img/instagram.svg';
import Youtube from '../img/youtube.svg';
import ColombiaMap from '../img/colombia.png';

// Importa imágenes de ejemplo para la galería
import GalleryImage1 from '../img/proyectos/1.jpg';
import GalleryImage2 from '../img/proyectos/2.jpg';
import GalleryImage3 from '../img/proyectos/3.jpg';

const SuccessCases = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [selectedDepartment, setSelectedDepartment] = useState(null);

    const socialMedia = [
        { icon: FacebookIcon, alt: 'Facebook', link: '#' },
        { icon: InstagramIcon, alt: 'Instagram', link: '#' },
        { icon: Youtube, alt: 'Youtube', link: '#' }
    ];

    const departments = [
        {
            id: 'meta',
            name: 'Meta',
            position: { x: 55, y: 50 },
            description: 'Hemos instalado más de 50 sistemas solares en el Meta, proporcionando energía limpia a comunidades rurales y fincas ganaderas.',
            projects: '15 proyectos residenciales, 35 proyectos agropecuarios',
            impact: 'Reducción del 80% en costos energéticos para nuestros clientes',
            images: [GalleryImage1, GalleryImage2, GalleryImage3]
        },
        {
            id: 'cundinamarca',
            name: 'Cundinamarca',
            position: { x: 39, y: 40 },
            description: 'En Cundinamarca hemos implementado sistemas solares para pequeñas empresas y hogares, con un enfoque en sostenibilidad urbana.',
            projects: '28 proyectos residenciales, 12 proyectos comerciales',
            impact: 'Ahorro promedio de $200,000 mensuales por cliente',
            images: [GalleryImage2, GalleryImage3, GalleryImage1]
        },
        {
            id: 'casanare',
            name: 'Casanare',
            position: { x: 60, y: 40 },
            description: 'Nuestros proyectos en Casanare se han enfocado en la industria petrolera, demostrando que la energía solar puede complementar los procesos industriales.',
            projects: '5 proyectos industriales, 8 proyectos residenciales',
            impact: 'Reducción de 120 toneladas de CO2 anuales',
            images: [GalleryImage3, GalleryImage1, GalleryImage2]
        },
        {
            id: 'huila',
            name: 'Huila',
            position: { x: 30, y: 53 },
            description: 'En el Huila hemos llevado energía solar a zonas cafeteras, mejorando los procesos de secado y almacenamiento del café con energía limpia.',
            projects: '22 proyectos agroindustriales, 10 proyectos residenciales',
            impact: 'Ahorro del 60% en costos energéticos para productores de café',
            images: [GalleryImage1, GalleryImage3, GalleryImage2]
        },
        {
            id: 'vaupes',
            name: 'Vaupés',
            position: { x: 68, y: 65 },
            description: 'Nuestros proyectos en Vaupés han llevado energía solar a comunidades indígenas, mejorando su calidad de vida y preservando su entorno natural.',
            projects: '8 proyectos comunitarios, 3 proyectos educativos',
            impact: 'Electrificación de 5 comunidades aisladas',
            images: [GalleryImage2, GalleryImage1, GalleryImage3]
        },
        {
            id: 'inirida',
            name: 'Guainía',
            position: { x: 80, y: 55 },
            description: 'En Inírida hemos implementado sistemas solares para centros de salud y escuelas, garantizando servicios básicos con energía renovable.',
            projects: '4 proyectos institucionales, 6 proyectos residenciales',
            impact: '24 horas de energía continua para centros médicos',
            images: [GalleryImage3, GalleryImage2, GalleryImage1]
        }
    ];

    const handleDepartmentClick = (dept) => {
        setSelectedDepartment(dept);
    };

    return (
        <Box sx={{ backgroundColor: '#313131', minHeight: '100vh' }}>
            <Navbar />

            <Box sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                minHeight: 'calc(100vh - 64px)',
                p: isMobile ? 2 : 6,
                position: 'relative'
            }}>
                {/* Sección izquierda */}
                <Box sx={{
                    width: isMobile ? '100%' : '50%',
                    display: 'flex',
                    flexDirection: 'column',
                    pr: isMobile ? 0 : 4,
                    mb: isMobile ? 4 : 0,
                    position: 'relative'
                }}>
                    {/* Redes sociales desktop */}
                    {!isMobile && (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3,
                            position: 'absolute',
                            left: 0,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 2
                        }}>
                            {socialMedia.map((social, index) => (
                                <Box
                                    component="img"
                                    key={index}
                                    src={social.icon}
                                    alt={social.alt}
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.1)',
                                            filter: 'drop-shadow(0 0 5px #EBC848)'
                                        }
                                    }}
                                />
                            ))}
                        </Box>
                    )}

                    {/* Contenido principal */}
                    <Box sx={{ ml: isMobile ? 0 : '60px' }}>
                        <Typography variant="h2" sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 700,
                            color: '#EBC848',
                            fontSize: isSmallMobile ? '1.5rem' : isMobile ? '1.8rem' : '2rem',
                            lineHeight: 1.2,
                            mb: 2,
                            textTransform: 'uppercase',
                            textAlign: isMobile ? 'center' : 'left'
                        }}>
                            CASOS DE ÉXITO
                        </Typography>

                        <Typography variant="body1" sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 400,
                            color: 'white',
                            fontSize: isMobile ? '0.8rem' : '0.9rem',
                            lineHeight: 1.6,
                            textAlign: isMobile ? 'center' : 'left'
                        }}>
                            Descubre nuestros proyectos destacados en diferentes regiones de Colombia.
                            Haz clic en los puntos del mapa para conocer más detalles.
                        </Typography>

                        {/* Card de departamento */}
                        {selectedDepartment ? (
                            <Box sx={{
                                mt: 4,
                                p: 3,
                                backgroundColor: 'rgba(49, 49, 49, 0.95)',
                                border: '2px solid #EBC848',
                                boxShadow: '0 0 15px #EBC848',
                                borderRadius: '4px'
                            }}>
                                <Typography variant="h3" sx={{
                                    fontFamily: 'Montserrat, sans-serif',
                                    fontWeight: 700,
                                    color: '#EBC848',
                                    fontSize: '1.5rem',
                                    mb: 2,
                                    textTransform: 'uppercase'
                                }}>
                                    {selectedDepartment.name}
                                </Typography>
                                <Typography variant="body1" sx={{
                                    fontFamily: 'Montserrat, sans-serif',
                                    fontWeight: 400,
                                    color: 'white',
                                    fontSize: '0.9rem',
                                    lineHeight: 1.6,
                                    mb: 3
                                }}>
                                    {selectedDepartment.description}
                                </Typography>
                                <Typography variant="body1" sx={{
                                    fontFamily: 'Montserrat, sans-serif',
                                    fontWeight: 600,
                                    color: '#EBC848',
                                    fontSize: '0.85rem',
                                    lineHeight: 1.6
                                }}>
                                    Proyectos realizados: <span style={{ color: 'white', fontWeight: 400 }}>{selectedDepartment.projects}</span>
                                </Typography>
                                <Typography variant="body1" sx={{
                                    fontFamily: 'Montserrat, sans-serif',
                                    fontWeight: 600,
                                    color: '#EBC848',
                                    fontSize: '0.85rem',
                                    lineHeight: 1.6,
                                    mt: 1
                                }}>
                                    Impacto: <span style={{ color: 'white', fontWeight: 400 }}>{selectedDepartment.impact}</span>
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{
                                mt: 4,
                                p: 3,
                                backgroundColor: 'rgba(49, 49, 49, 0.5)',
                                border: '2px dashed #EBC848',
                                borderRadius: '4px',
                                textAlign: 'center'
                            }}>
                                <Typography variant="body1" sx={{
                                    fontFamily: 'Montserrat, sans-serif',
                                    fontWeight: 400,
                                    color: 'white',
                                    fontSize: '0.9rem',
                                }}>
                                    Selecciona un departamento en el mapa para ver los detalles del proyecto
                                </Typography>
                            </Box>
                        )}

                        {/* Galería */}
                        <Box sx={{ mt: 4 }}>
                            <Typography variant="h4" sx={{
                                fontFamily: 'Montserrat, sans-serif',
                                fontWeight: 600,
                                color: '#EBC848',
                                fontSize: '1.2rem',
                                mb: 2,
                                textTransform: 'uppercase'
                            }}>
                                Galería de Proyectos
                            </Typography>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                                gap: 2
                            }}>
                                {(selectedDepartment?.images || [GalleryImage1, GalleryImage2, GalleryImage3]).map((img, index) => (
                                    <Box
                                        key={index}
                                        component="img"
                                        src={img}
                                        alt={`Proyecto ${index + 1}`}
                                        sx={{
                                            width: '100%',
                                            height: '120px',
                                            objectFit: 'cover',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            transition: 'transform 0.3s',
                                            '&:hover': {
                                                transform: 'scale(1.05)',
                                                boxShadow: '0 0 10px #EBC848'
                                            }
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>
                    </Box>

                    {/* Redes sociales mobile */}
                    {isMobile && (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 3,
                            mt: 4
                        }}>
                            {socialMedia.map((social, index) => (
                                <Box
                                    component="img"
                                    key={index}
                                    src={social.icon}
                                    alt={social.alt}
                                    sx={{
                                        width: 35,
                                        height: 35,
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.1)',
                                            filter: 'drop-shadow(0 0 5px #EBC848)'
                                        }
                                    }}
                                />
                            ))}
                        </Box>
                    )}
                </Box>

                {/* Sección derecha (mapa) */}
                <Box sx={{
                    width: isMobile ? '100%' : '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <Box sx={{
                        width: '100%',
                        maxWidth: '600px',
                        position: 'relative'
                    }}>
                        <Box
                            component="img"
                            src={ColombiaMap}
                            alt="Mapa de Colombia"
                            sx={{
                                width: '100%',
                                height: 'auto',
                                filter: 'brightness(0.8) contrast(1.2)'
                            }}
                        />

                        {departments.map((dept) => (
                            <Box
                                key={dept.id}
                                onClick={() => handleDepartmentClick(dept)}
                                sx={{
                                    position: 'absolute',
                                    left: `${dept.position.x}%`,
                                    top: `${dept.position.y}%`,
                                    width: '12px',
                                    height: '12px',
                                    backgroundColor: 'red',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    transform: 'translate(-50%, -50%)',
                                    boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.8), 0 0 10px 5px rgba(255, 0, 0, 0.7)',
                                    transition: 'all 0.3s',
                                    animation: 'pulse 2s infinite',
                                    '&:hover': {
                                        transform: 'translate(-50%, -50%) scale(1.5)'
                                    }
                                }}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>

            {/* Animación de pulso para los puntos */}
            <style>
                {`
          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
            }
            70% {
              box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
            }
          }
        `}
            </style>
        </Box>
    );
};

export default SuccessCases;